import { NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import { stellarCommunityFundData } from './StellarCommunityFund.data';
import {
  StyledSection,
  StyledStack,
  StyledHeaderStack,
  StyledTitle,
  StyledIntro,
  StyledCardsWrapper,
  StyledGrantCard,
  StyledGrantBadge,
  StyledGrantTitle,
  StyledGrantDescription,
  StyledGrantLink,
  StyledQuoteWrapper,
  StyledQuoteText,
  StyledQuoteAuthor,
  StyledClosing,
} from './styles';

export const StellarCommunityFund = () => {
  return (
    <StyledSection width="normal">
      <StyledStack>
        <NameBanner
          type="section"
          text={stellarCommunityFundData.sectionLabel}
          color="yellow"
        />
        <StyledHeaderStack>
          <StyledTitle variant="display_sm">
            {stellarCommunityFundData.title}
          </StyledTitle>
          <StyledIntro variant="regular_400">
            {stellarCommunityFundData.intro}
          </StyledIntro>
        </StyledHeaderStack>

        <StyledCardsWrapper>
          {stellarCommunityFundData.grants.map((grant, index) => (
            <StyledGrantCard key={index}>
              <StyledGrantBadge>{grant.badge}</StyledGrantBadge>
              <StyledGrantTitle variant="strong_500">
                {grant.title}
              </StyledGrantTitle>
              <StyledGrantDescription variant="regular_400">
                {grant.description}
              </StyledGrantDescription>
              <StyledGrantLink to={grant.linkHref}>
                {grant.linkText}
              </StyledGrantLink>
            </StyledGrantCard>
          ))}
        </StyledCardsWrapper>

        <StyledQuoteWrapper>
          <StyledQuoteText variant="regular_500">
            {stellarCommunityFundData.quote.text}
          </StyledQuoteText>
          <StyledQuoteAuthor variant="regular_300">
            — {stellarCommunityFundData.quote.author}
          </StyledQuoteAuthor>
        </StyledQuoteWrapper>

      </StyledStack>
    </StyledSection>
  );
};
